import './radioButton.scss';
import type {RadioButton_iconAndImg_Props} from "./RadioButton.interface";
import {Icon} from "../../Basic/Icon";
import {Paragraph} from "../../Elements/Paragraph";
import {useTranslation} from "react-i18next";
import {I18NParagraph} from "../../Elements/I18NParagraph";

/**
 * Primary UI component for user interaction
 */
export function IconAndImgRadioButton  (props: RadioButton_iconAndImg_Props) {
    
    const {t} = useTranslation();
    
    return (
        <div className={["radiobutton-wrapper", props.className, props.hide ? "hide" : "", props.recommended ? "highlight" : "no-highlight"].join(" ")}>
            { props.recommended &&
            <div className={"recommended-container"} onClick={props.disabled ? () => {} : props.onClick}>
                <div className={"recommended"}>{t("button.recommended")}</div> 
                <I18NParagraph i18n={"fidoRegistration.startRegistration.currentDev"} />
            </div>
            }
            <div className="radiobutton-input-row" onClick={props.disabled ? () => {} : props.onClick}>
                <div className="input">
                    <input id={props.id}
                           aria-label={props.id}
                           type="radio"
                           readOnly
                           disabled={props.disabled}
                           checked={props.disabled ? false : props.selected}
                    />
                </div>
                <div className={["image", props.disabled ? "disabled" : ""].join(" ")}>
                    <Icon icon={props.icon}/>
                </div>
                <div className={props.disabled ? "disabled" : ""}>
                    <label htmlFor={props.id} aria-label={props.id}>
                        {props.label}
                    </label>
                </div>
            </div>
            { props.disabled && props.disabledDescription &&
                <div className="radiobutton-content-row disable-description">
                        <Paragraph text={props.disabledDescription} className={"note"}/>
                </div>
            }
            {/*this is needet for gifs to restart in chrome*/}
            <div className={["radiobutton-content-row", props.selected ? "" : "hide"].join(" ")}>
                <div className="image">
                    <Icon id={props.id ? props.id + "-image" : undefined} icon={props.selected ? props.image : undefined}/>
                </div>
                <div className={["text"].join(" ")}>
                    <Paragraph text={props.text}/>
                </div>
            </div>
        </div>
    );
}
